
import { ISetTieuChuan, ISetTieuChuanViewModel } from "../../../model/respone/set-tieu-chuan/ISetTieuChuan"
import { ISetTieuChuanImportRequest } from "../../../model/request/set-tieu-chuan/ISetTieuChuanImportRequest"
import { ISetTieuChuanImportResponse } from "../../../model/respone/set-tieu-chuan/ISetTieuChuanImportResponse"
import { generateActionTypeIds } from "../generateActionTypeIds"
import IGenericActionType from "../IGenericActionType"

export const eSetTieuChuanActionTypeDefine = {
    LOAD_START: {} as number,
    LOAD_SUCCESS: {} as ISetTieuChuanViewModel[],
    LOAD_ERROR: "",

    SHOW_EDIT_MODAL: {} as undefined | ISetTieuChuan,
    CLOSE_EDIT_MODAL: undefined,
    
    SAVE_START: {} as ISetTieuChuan,
    SAVE_SUCCESS: {} as ISetTieuChuan,
    SAVE_ERROR: "",

    DELETE_START: 0,
    DELETE_SUCCESS: undefined,
    DELETE_ERROR: "",

    CHANGE_SELECTED_ID: 0,

    SHOW_IMPORT_MODAL: undefined,
    CLOSE_IMPORT_MODAL: undefined,

    SAVE_IMPORT_START: {} as ISetTieuChuanImportRequest,
    SAVE_IMPORT_SUCCESS: {} as ISetTieuChuanImportResponse,
    SAVE_IMPORT_ERROR: "",


}
export const eSetTieuChuanActionTypeIds = generateActionTypeIds(eSetTieuChuanActionTypeDefine, "SET_TIEU_CHUAN")

export type ISetTieuChuanActions = IGenericActionType<typeof eSetTieuChuanActionTypeDefine, "SET_TIEU_CHUAN">